import { render, staticRenderFns } from "./fileUploadSimpleComponent.vue?vue&type=template&id=cdc8be36"
import script from "./fileUploadSimpleComponent.vue?vue&type=script&lang=js"
export * from "./fileUploadSimpleComponent.vue?vue&type=script&lang=js"
import style0 from "./fileUploadSimpleComponent.vue?vue&type=style&index=0&id=cdc8be36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports